module.exports = __webpack_public_path__ + "media/assets/avatar-72e3e3969d79a7cc76900f0429554989.png";